import React, { Component } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

class TouchGestureOmaha extends Component {
  constructor(props) {
    super(props);

    this._startButtonRef = null;
    this._intervalFadeA = null;
    this._intervalFadeB = null;
    this._screensNumber = 1;

    this.state = {
      showButton: true
    };
  }

  componentDidMount() {
    this.startFadeInterval(this.state.showButton);
  }

  componentWillUnmount() {
    clearTimeout(this._intervalFadeA);
    clearTimeout(this._intervalFadeB);
  }

  animateStartButton = (show) => {
    if (this._startButtonRef) {
      if (show) {
        this._startButtonRef.animate(
          [
            {
              transform: "scale(1)"
            },
            {
              transform: "scale(1.25)"
            }
          ],
          {
            fill: "forwards",
            duration: 2000
          }
        );
      } else {
        this._startButtonRef.animate(
          [
            {
              transform: "scale(1.25)"
            },
            {
              transform: "scale(0.75)"
            }
          ],
          {
            fill: "forwards",
            duration: 2000
          }
        );
      }
    }
  };

  startFadeInterval = (status) => {
    const newStatus = !status;
    if (newStatus) {
      clearTimeout(this._intervalFade);
      this._intervalFadeA = setTimeout(() => {
        this.setState({
          showButton: newStatus
        });
        this.animateStartButton(newStatus);
        this.startFadeInterval(newStatus);
      }, 5000);
    } else {
      clearTimeout(this._intervalFade);
      this._intervalFadeB = setTimeout(() => {
        this.animateStartButton(newStatus);
        setTimeout(() => {
          this.setState({
            showButton: newStatus
          });
          this.startFadeInterval(newStatus);
        }, 2000);
      }, 5000);
    }
  };

  render() {
    return (
      <div style={{ position: "absolute", top: this.props.contentY, left: this.props.contentX }}>
        <CSSTransitionGroup
          component="div"
          className="containerFade"
          style={{ minHeight: "100%" }}
          transitionName="example"
          transitionEnterTimeout={2000}
          transitionLeaveTimeout={2000}
        >
          <div key={this.state.showButton}>
            {this.state.showButton ? (
              <div
                ref={(el) => (this._startButtonRef = el)}
                style={{
                  position: "absolute",
                  top: "43.356510416vh",
                  width: this.props.screen.screenWidth / this._screensNumber,
                  height: "5vh",
                  textAlign: "center"
                }}
              >
                <div style={{ width: "100%" }}>
                  <img style={{ maxWidth: "12vh", maxHeight: "12vh" }} src="/img/miami/ui/start.png" alt="" />
                </div>
              </div>
            ) : null}
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default TouchGestureOmaha;



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/TouchGestureOmaha.jsx